import { Component, Input, OnInit } from '@angular/core';
import { Home } from '../../interfaces/page';

@Component({
  selector: 'app-home-section-menu',
  templateUrl: './home-section-menu.component.html',
  styleUrls: ['./home-section-menu.component.scss']
})
export class HomeSectionMenuComponent implements OnInit {
  @Input() content: Home;

  constructor() { }

  ngOnInit() {
  }

}
